/* ==========================================================================
   Glutathione add-on  ·  Root Labs  ·  built 2026-09-25
   Loaded as a theme asset so it costs the 256KB templates almost nothing.

   Contract with the page (the ONLY two things the template must do):
     1. load this file
     2. in bb6AddToCartAndRedirect, replace
            url += "&return_to=/checkout";
        with
            url += "&return_to=" + encodeURIComponent(window.__glutaReturnTo
                     ? window.__glutaReturnTo(BB6_STATE.mode) : "/checkout");

   Offer: ALWAYS one 30-day pack. Mirrors one-time vs subscribe, never the pack.
   ========================================================================== */
(function () {
  "use strict";

  /* ---- the single source of truth for the offer ------------------------ */
  var G = {
    variant: 47149902037167,        // Glutathione Gummies · 1-Pack
    plan:    "3483107503",          // Loop "Add-on Glutathione offer": -$10 cycle 1, -$0 after, every 30 days
    first:   19.99,                 // shown as today's price on subscribe
    renew:   29.99,
    onetime: 29.99,
    strike:  47.99,                 // matches the variant compare-at price on the live product
    days:    30,
    img:     "https://cdn.shopify.com/s/files/1/0671/4854/6223/files/gg-hero-01.png?v=1783422843"
  };

  var COPY = {
    pre:  "Customers also add",
    name: "Glutathione Gummies",
    tag:  "for beauty sleep",
    sub:  "The magnesium works on your sleep. This works on your skin while you are in it. " +
          "250mg OPITAC™ Japanese glutathione with Vitamin C &amp; A, third-party tested."
  };

  var KIND = document.getElementById("v8MainCta") ? "product"
           : document.getElementById("buyCta")   ? "listicle" : null;
  if (!KIND) return;

  var OPTS_PLACEMENT = "below";
  var ON = false;                                    // starts unticked, by design
  var mod = null;

  function track(ev, props) {
    try {
      var t = window.__v8Telemetry || window.bb6Telemetry;
      if (t && typeof t.track === "function") { t.track(ev, props || {}); return true; }
    } catch (e) {}
    return false;
  }
  function cta() { return document.getElementById(KIND === "product" ? "v8MainCta" : "buyCta"); }
  /* write ONLY on change. A MutationObserver watching this subtree would otherwise
     re-fire on our own writes and spin the main thread forever. */
  function setHTML(el, html) { if (el && el.innerHTML !== html) el.innerHTML = html; }
  function setText(el, txt)  { if (el && el.textContent !== txt) el.textContent = txt; }
  function money(n) { return "$" + n.toFixed(2); }
  function whole(n) { return n % 1 === 0 ? "$" + n.toFixed(0) : money(n); }
  function mode() {
    if (KIND === "product") {
      var m = document.querySelector(".type-opt.sel");
      return m && m.dataset.v8Mode === "onetime" ? "onetime" : "subscribe";
    }
    var o = document.querySelector(".buy-mode-opt.is-active");
    return o && o.dataset.mode === "onetime" ? "onetime" : "subscribe";
  }
  function price() { return mode() === "subscribe" ? G.first : G.onetime; }

  /* ---- what the buy button must chain to ------------------------------- */
  window.__glutaReturnTo = function (pageMode) {
    if (!ON) return "/checkout";
    var u = "/cart/add?id=" + G.variant + "&quantity=1";
    if ((pageMode || mode()) === "subscribe" && G.plan) u += "&selling_plan=" + G.plan;
    u += "&attributes[addon]=glutathione_30d";
    u += "&return_to=/checkout";
    return u;
  };
  window.__glutaState = function () { return { on: ON, variant: G.variant, price: price() }; };

  /* ---- styles ---------------------------------------------------------- */
  var CSS = [
    "#rlgAddon{--a:#003e2c;margin:14px 0;border:1.5px solid var(--a);border-radius:14px;",
    "background:rgba(255,255,255,.72);box-shadow:0 1px 2px rgba(0,0,0,.05);font-family:inherit;",
    "text-align:left;overflow:hidden;cursor:pointer;-webkit-tap-highlight-color:transparent}",
    "#rlgAddon.off{border-color:rgba(0,0,0,.14);background:rgba(255,255,255,.45)}",
    "#rlgAddon .gh{display:flex;align-items:center;gap:8px;padding:10px 10px 0}",
    "#rlgAddon .gsw{flex:0 0 34px;width:34px;height:20px;border-radius:999px;background:#c9c4b4;",
    "position:relative;transition:background .15s}",
    "#rlgAddon:not(.off) .gsw{background:var(--a)}",
    "#rlgAddon .gkn{position:absolute;top:2px;left:2px;width:16px;height:16px;border-radius:50%;",
    "background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}",
    "#rlgAddon:not(.off) .gkn{transform:translateX(14px)}",
    "#rlgAddon .gim{flex:0 0 30px;width:30px;height:30px;border-radius:8px;object-fit:cover;",
    "border:1px solid rgba(0,0,0,.09);background:#fff}",
    "#rlgAddon .gbd{flex:1 1 auto;min-width:0}",
    "#rlgAddon .gtop{display:flex;align-items:baseline;justify-content:space-between;gap:8px}",
    "#rlgAddon .gpre{font-family:inherit;font-size:9px;font-weight:800;letter-spacing:.05em;",
    "text-transform:uppercase;color:#6d6a5e;line-height:1.2;white-space:nowrap;",
    "flex:1 1 auto;min-width:0;overflow:hidden;text-overflow:ellipsis}",
    "#rlgAddon .gpr{flex:0 0 auto;font-size:13.5px;font-weight:800;white-space:nowrap;",
    "font-variant-numeric:tabular-nums;color:var(--a)}",
    "#rlgAddon .gwas{font-size:10.5px;font-weight:600;color:#6d6a5e;text-decoration:line-through;margin-right:3px}",
    "#rlgAddon .gnm{font-family:Georgia,'Times New Roman',serif;font-size:14px;font-weight:600;",
    "letter-spacing:-.012em;line-height:1.25;color:#1d1c18;margin:1px 10px 0;min-width:0}",
    "#rlgAddon .gnmn{white-space:nowrap}",
    "#rlgAddon .gtag{font-family:Georgia,serif;font-style:italic;font-weight:400;font-size:13px;",
    "color:#6d6a5e;white-space:nowrap}",
    "#rlgAddon .gsub{font-size:11.5px;line-height:1.45;color:#6d6a5e;margin:5px 10px 0}",
    "#rlgAddon .gtr{font-size:9.5px;line-height:1.35;color:#6d6a5e;margin:5px 10px 11px}",
    ".rlg-cta-was{font-size:.7em;font-weight:500;opacity:.55;margin-left:.15em;letter-spacing:.02em;text-decoration:line-through;text-decoration-thickness:1px;white-space:nowrap}",
    "#v8MainCtaPrice,#buyCtaPrice{white-space:nowrap}",
    "#buyCta,#v8MainCta .btn-buy-main{white-space:nowrap}",
    ".rlg-ship{position:absolute;top:0;right:14px;transform:translateY(-50%);background:#fff;",
    "color:#003e2c;font-family:inherit;font-size:9px;font-weight:800;letter-spacing:.1em;",
    "text-transform:uppercase;line-height:1;padding:5px 10px 4px;border-radius:999px;",
    "white-space:nowrap;border:1.5px solid #003e2c;box-shadow:0 1px 4px rgba(0,0,0,.14);pointer-events:none}",
    ".rlg-was{font-size:.58em;font-weight:500;opacity:.5;text-decoration:line-through;",
    "text-decoration-thickness:1px;margin:0 .45em 0 .55em;vertical-align:.16em}",
    ".pack-grid,.pack-card,.pack-card>*{min-width:0}",
    "[data-v8-cadence]{width:100%;min-width:0;white-space:nowrap}",
    ".pack-card{padding-left:5px!important;padding-right:5px!important}"
  ].join("");

  function injectCSS() {
    if (document.getElementById("rlgCss")) return;
    var s = document.createElement("style");
    s.id = "rlgCss"; s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ---- module ---------------------------------------------------------- */
  function render() {
    var sub = mode() === "subscribe";
    if (mod.className !== (ON ? "" : "off")) mod.className = ON ? "" : "off";
    setHTML(mod,
      '<div class="gh"><span class="gsw"><span class="gkn"></span></span>' +
        '<img class="gim" src="' + G.img + '" alt="Glutathione Gummies">' +
        '<div class="gbd"><div class="gtop"><span class="gpre">' + COPY.pre + "</span>" +
          '<span class="gpr"><s class="gwas">' + money(G.strike) + "</s>" + money(price()) + "</span>" +
        "</div></div></div>" +
      '<div class="gnm"><span class="gnmn">' + COPY.name + '</span> <span class="gtag">' + COPY.tag + "</span></div>" +
      '<div class="gsub">' + COPY.sub + "</div>" +
      '<div class="gtr">' + (sub ? "Renews every " + G.days + " days · cancel anytime"
                                 : "One-time purchase · no subscription") + "</div>");
    paintCta();
  }

  /* the button shows one combined total, with the combined crossed-out price */
  function paintCta() {
    var el = document.getElementById(KIND === "product" ? "v8MainCtaPrice" : "buyCtaPrice");
    if (!el) return;
    var base = readBase();
    if (base == null) return;
    var total = base.now + (ON ? price() : 0);
    var was   = base.was + (ON ? G.strike : 0);
    var cents = total.toFixed(2).split(".");
    var charm = cents[1] === "00" ? "$" + cents[0]
              : "$" + cents[0] + '<sup class="pc-cents">' + cents[1] + "</sup>";
    setHTML(el, charm + (was > total ? ' <s class="rlg-cta-was">' + whole(was) + "</s>" : ""));
  }

  /* read the page's own selected price straight off the DOM: no duplicated price table */
  /* the page renders $65<sup class="pc-cents">99</sup>, so textContent reads "$6599".
     Parse the sup separately or you get 6599.00. This bit me once already. */
  function readMoney(el) {
    if (!el) return 0;
    var sup = el.querySelector("sup");
    var cents = sup ? sup.textContent.replace(/\D/g, "") : "";
    var clone = el.cloneNode(true);
    var cs = clone.querySelector("sup");
    if (cs) cs.parentNode.removeChild(cs);
    var dollars = clone.textContent.replace(/[^0-9]/g, "");
    if (!dollars) return 0;
    if (!sup) {                       /* plain "$70.99" or "$88" */
      var m = el.textContent.match(/(\d+)(?:\.(\d{1,2}))?/);
      return m ? parseFloat(m[1] + "." + ((m[2] || "0") + "0").slice(0, 2)) : 0;
    }
    return parseFloat(dollars + "." + ((cents || "0") + "0").slice(0, 2));
  }

  function readBase() {
    var card = document.querySelector(KIND === "product" ? ".pack-card.sel" : ".buy-pack.is-active");
    if (!card) return null;
    var p = card.querySelector(KIND === "product" ? "[data-v8-price]" : "[data-price]");
    if (!p) return null;
    var now = readMoney(p);
    if (!(now > 0) || now > 500) return null;          /* refuse to render a nonsense total */
    var was = readMoney(card.querySelector("[data-strike-el]"));
    if (!was) {                       /* product has no compare-at node: derive it, never hardcode */
      /* only when the page is itself showing that saving. in one-time mode it hides the
         tag, because the saving is the subscribe discount: don't claim it on the CTA. */
      var sv = card.querySelector("[data-v8-save],[data-save]");
      if (sv && (sv.offsetWidth || sv.offsetHeight)) {
        var sm = (sv.textContent || "").match(/\$\s*([\d.]+)/);
        if (sm) was = Math.round(now + parseFloat(sm[1]));
      }
    }
    return { now: now, was: was };
  }

  function shipPill() {
    if (KIND !== "product") return;
    var c = cta();
    if (!c || c.querySelector(".rlg-ship")) return;
    var p = document.createElement("span");
    p.className = "rlg-ship"; p.textContent = "Free shipping";
    c.style.position = "relative"; c.style.overflow = "visible";
    c.appendChild(p);
  }

  function tidyCadence() {
    if (KIND !== "product") return;
    document.querySelectorAll("[data-v8-cadence]").forEach(function (el) {
      var t = el.textContent || "";
      /* leave the renewal line alone: it carries the free-shipping reassurance and
         removing it is the last untested change from the 09-25 deploy. */
      if (/one-time/i.test(t)) el.textContent = "One-time order";
    });
  }

  function place() {
    var c = cta();
    if (!c || !c.parentNode) return;
    var pill = document.getElementById("buyDiscountPill");          // listicle: stays above us
    if (KIND === "listicle" && pill && pill.parentNode &&
        (pill.compareDocumentPosition(c) & Node.DOCUMENT_POSITION_PRECEDING)) {
      pill.parentNode.insertBefore(mod, pill.nextSibling);
    } else {
      c.parentNode.insertBefore(mod, c.nextSibling);
    }
  }

  function boot() {
    if (!cta() || document.getElementById("rlgAddon")) return;
    injectCSS();
    mod = document.createElement("div");
    mod.id = "rlgAddon";
    mod.setAttribute("role", "checkbox");
    mod.setAttribute("aria-checked", "false");
    mod.addEventListener("click", function () {
      ON = !ON;
      mod.setAttribute("aria-checked", ON ? "true" : "false");
      render();
      track("gluta_addon_toggled", { on: ON, mode: mode(), price: price(),
                                     page: KIND, variant_id: G.variant });
    });
    place(); render(); shipPill(); tidyCadence();

    /* the -gluta templates report the same lp_variant as the originals, so without
       this we have no way to count who actually saw the add-on. Fire once. */
    if (!window.__glutaShown) {
      window.__glutaShown = true;
      setTimeout(function () {
        track("gluta_addon_shown", { page: KIND, placement: OPTS_PLACEMENT,
                                     price: price(), mode: mode() });
      }, 800);
    }

    /* the page re-renders its buy box on every pack/plan change; follow it */
    var host = document.getElementById("buyBox") ||
               (document.querySelector(".pack-grid") || {}).parentNode || document.body;
    try {
      var queued = false, busy = false;
      var obs = new MutationObserver(function (recs) {
        if (busy || queued) return;
        /* our own writes must never re-trigger us */
        for (var i = 0; i < recs.length; i++) {
          var n = recs[i].target;
          if (n && n.nodeType === 1 && n.closest && n.closest("#rlgAddon")) return;
        }
        queued = true;
        requestAnimationFrame(function () {
          queued = false; busy = true;
          try {
            if (!document.getElementById("rlgAddon")) place();
            tidyCadence(); paintCta();
          } finally { busy = false; }
        });
      });
      obs.observe(host, { childList: true, subtree: true });
    } catch (e) {}
    document.addEventListener("click", function (e) {
      if (e.target.closest(".pack-card,.type-opt,.buy-pack,#buyOnetimeLink"))
        setTimeout(function () { render(); tidyCadence(); }, 30);
    }, true);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  window.addEventListener("load", function () { boot(); shipPill(); tidyCadence(); paintCta(); });
})();
